import ReactApexChart from 'react-apexcharts'
import React from 'react';



class Treemap extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
      
        series: [
          {
            data:this.props.db
          }
        ],
        options: {
          legend: {
            show: false
            
          },
          chart: {
            height: this.props.height,
            type: 'treemap'
          },
          title: {
            // text: 'Basic Treemap'
          },


          colors: [
            '#3B93A5',
            '#F7B844',
            '#ADD8C7',
            '#EC3C65',
            '#CDD7B6',
            '#C1F666',
            '#D43F97',
            '#1E5D8C',
            '#421243',
            '#7F94B0',
            '#EF6537',
            '#C0ADDB'
          ],
          plotOptions: {
            treemap: {
              distributed: true,
              enableShades: false
            }
          }
        },
      
      
      };
    }

  

    render() {
      return (
        

  <div id="chart">
<ReactApexChart options={this.state.options} series={this.state.series} type="treemap" height={this.props.height} />
</div>

      )
    }
}

export default Treemap;